<script>
	import { createEventDispatcher } from "svelte";
	import { validate } from "$misc/actions";

	export let value = "";
	export let label = "Email";
	export let name = "email";
	export let placeholder = "";
	export let required = true;
	export let asterisk = false;

	export const trigger = () => {
		const node = document.querySelector(`#${name}`);
		node.focus();
		node.blur();
	};

	const dispatch = createEventDispatcher();

	const send_validation_state = (node) => {
		const parent = node.parentElement;

		const input = () => {
			const valid = node.validity.valid;

			setTimeout(() => {
				const data = {
					valid: valid && !parent.classList.contains("field--invalid"),
				};
				dispatch("validate", data);
			}, 100);
		};

		const change = () => {
			const valid = node.validity.valid;
			setTimeout(() => {
				const data = {
					valid: valid && !parent.classList.contains("field--invalid"),
				};
				dispatch("validate", data);
			}, 100);
		};

		node.addEventListener("input", input);
		node.addEventListener("change", change);

		if (value) {
			node.dispatchEvent(new Event("change"));
		}

		return {
			destroy() {
				node.removeEventListener("input", input);
				node.removeEventListener("change", change);
			},
		};
	};
</script>

<div class="form-group">
	<label for={name} class:asterisk>{label}</label>
	<input
		use:validate={"email"}
		use:send_validation_state
		class="form-control"
		type="email"
		id={name}
		{name}
		autocomplete="off"
		placeholder={placeholder || label}
		{value}
		{required}
	/>
</div>

<style>
	label.asterisk::after {
		content: " *";
		color: red;
	}
</style>
